module.exports = __webpack_public_path__ + "static/media/S2b2cbg.b1bbf24a.png";